import { types } from "mobx-state-tree";
import { useRef } from "react";
/** @internal */
export const actionStateStoreModel = types
    .model({
    isActive: types.boolean,
    triggerIsBusy: types.boolean,
    isCheckingPrecondition: types.boolean,
    activeFeedback: types.maybeNull(types.enumeration(["success", "error"])),
})
    .actions((self) => ({
    setIsTriggerBusy: (isBusy) => {
        self.triggerIsBusy = isBusy;
    },
    setIsActive: (isActive) => {
        self.isActive = isActive;
    },
    setIsCheckingPrecondition: (isCheckingPrecondition) => {
        self.isCheckingPrecondition = isCheckingPrecondition;
    },
    setActiveFeedback: (feedback) => {
        self.activeFeedback = feedback;
    },
}))
    .views((self) => ({
    get isBusy() {
        return (self.triggerIsBusy ||
            self.isCheckingPrecondition ||
            !!self.activeFeedback);
    },
}));
/** @internal */
export const useActionStateStore = (initialState) => {
    return useRef(actionStateStoreModel.create({
        triggerIsBusy: false,
        activeFeedback: null,
        isActive: false,
        isCheckingPrecondition: false,
        ...initialState,
    })).current;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2FjdGlvbnMvc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFtQixLQUFLLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUN6RCxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBRy9CLGdCQUFnQjtBQUNoQixNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRyxLQUFLO0tBQ3ZDLEtBQUssQ0FBQztJQUNMLFFBQVEsRUFBRSxLQUFLLENBQUMsT0FBTztJQUN2QixhQUFhLEVBQUUsS0FBSyxDQUFDLE9BQU87SUFDNUIsc0JBQXNCLEVBQUUsS0FBSyxDQUFDLE9BQU87SUFDckMsY0FBYyxFQUFFLEtBQUssQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxDQUFDLFNBQVMsRUFBRSxPQUFPLENBQUMsQ0FBQyxDQUFDO0NBQ3pFLENBQUM7S0FDRCxPQUFPLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDbEIsZ0JBQWdCLEVBQUUsQ0FBQyxNQUFlLEVBQVEsRUFBRTtRQUMxQyxJQUFJLENBQUMsYUFBYSxHQUFHLE1BQU0sQ0FBQztJQUM5QixDQUFDO0lBQ0QsV0FBVyxFQUFFLENBQUMsUUFBaUIsRUFBUSxFQUFFO1FBQ3ZDLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO0lBQzNCLENBQUM7SUFDRCx5QkFBeUIsRUFBRSxDQUFDLHNCQUErQixFQUFRLEVBQUU7UUFDbkUsSUFBSSxDQUFDLHNCQUFzQixHQUFHLHNCQUFzQixDQUFDO0lBQ3ZELENBQUM7SUFDRCxpQkFBaUIsRUFBRSxDQUFDLFFBQW9DLEVBQVEsRUFBRTtRQUNoRSxJQUFJLENBQUMsY0FBYyxHQUFHLFFBQVEsQ0FBQztJQUNqQyxDQUFDO0NBQ0YsQ0FBQyxDQUFDO0tBQ0YsS0FBSyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hCLElBQUksTUFBTTtRQUNSLE9BQU8sQ0FDTCxJQUFJLENBQUMsYUFBYTtZQUNsQixJQUFJLENBQUMsc0JBQXNCO1lBQzNCLENBQUMsQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUN0QixDQUFDO0lBQ0osQ0FBQztDQUNGLENBQUMsQ0FBQyxDQUFDO0FBVU4sZ0JBQWdCO0FBQ2hCLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHLENBQ2pDLFlBQW1DLEVBQ2pCLEVBQUU7SUFDcEIsT0FBTyxNQUFNLENBQ1gscUJBQXFCLENBQUMsTUFBTSxDQUFDO1FBQzNCLGFBQWEsRUFBRSxLQUFLO1FBQ3BCLGNBQWMsRUFBRSxJQUFJO1FBQ3BCLFFBQVEsRUFBRSxLQUFLO1FBQ2Ysc0JBQXNCLEVBQUUsS0FBSztRQUM3QixHQUFHLFlBQVk7S0FDaEIsQ0FBQyxDQUNILENBQUMsT0FBTyxDQUFDO0FBQ1osQ0FBQyxDQUFDIn0=